export default __webpack_public_path__ + "static/media/notice-close-icon.b39d9bcf.svg";